import { Routes } from '@angular/router';
import { ChatSuggestionsAdminComponent } from '@brighthub/copilot';
import { BrightnavAdminShellComponent } from '../layout/brightnav-admin-shell/brightnav-admin-shell.component';
import { BrightnavAdminHomeComponent } from '../layout/brightnav-admin-home/brightnav-admin-home.component';

/**
 * Lazy-loaded child routes mounted under `/brightnav/admin` from the BrightNav shell.
 * The parent route uses `authGroupGuard` with `BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP` from
 * `@brighthub/admin-contract` (see `brightnav.routes.ts`); this array only describes layout and pages.
 */
export const brightnavAdminFeatureRoutes: Routes = [
  {
    path: '',
    component: BrightnavAdminShellComponent,
    children: [
        {
          path: '',
          pathMatch: 'full',
          component: BrightnavAdminHomeComponent,
        },
        {
          path: 'suggestions',
          component: ChatSuggestionsAdminComponent,
        },
      ],
  },
];
